import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  actionHref?: string;
  onReset?: () => void;
}

export default function EmptyState({
  icon = "ri-search-line",
  title,
  description,
  actionLabel,
  actionHref,
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-primary-600">
        <i className={`${icon} text-2xl`} aria-hidden="true"></i>
      </span>
      <h3 className="text-lg font-bold">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onReset ? (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            重置筛选条件
          </button>
        ) : null}
        {actionLabel && actionHref ? (
          <Link
            to={actionHref}
            className="inline-flex items-center gap-1 rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {actionLabel}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        ) : null}
      </div>
    </div>
  );
}